import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
  MenuList,
  MenuItem,
  Td,
  Tr,
  Textarea,
  Card,
  CardBody,
  Divider,
  Input,
  SimpleGrid,
  Center,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import {
  DropdownInput,
  PasswordInput,
  PrimaryInput,
  PrimaryInputDropdown,
  SearchBar,
  Toaster,
} from "../../components";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import {
  formatDate_DD_MM_YYYY,
  formatDate_YYYY_MM_DD,
  getCroppedImg,
  getLoginID,
  handleAlphaDotAndSpace,
  handleNumericDotAndSpace,
  downloadDocument,
  useScreenType,
  formatDate_Do_MMM_YYYY,
  formatDate_Do_MMM_YYYY_Time,
} from "../../auth";
import {
  getProcurementList, getInvoiceDetails, UpdatePaymentstatus
} from "../../middleware/services/procurementmanagement/index";
import UploadInvoice from "./uploadinvoice";
import { set } from "date-fns";


const ProcurementsIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const screenType = useScreenType();
  const navigate = useNavigate();
  const [resultProcurementList, setResultProcurementList] = useState([]);
  const [InvoiceDetails, setInvoiceDetails] = useState([]);
  const [invoiceDetailsData, setInvoiceDetailsData] = useState({});
  const [pharmacyName, setPharmacyName] = useState(null);
  const [pharmacyType, setPharmacyType] = useState("null");
  const [genderId, setGenderId] = useState(null);
  const [branchid, setbranchid] = useState(null);
  const [refreshPageData, setRefreshPageData] = useState(false);
  const [showuploadinvoice, Setshowuploadinvoice] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [paymentID, setpaymentID] = useState(null);
  const [InvoiceNumber, setInvoiceNumber] = useState(null);
  const [PaymentStatus, setPaymentStatus] = useState("0");
  const invoicedetails = useRef();
  const paymentmodal = useRef();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [TotalCount, setTotalCount] = useState(0);


  const getProcurements = async () => {
    //setResultProcurementList(data)
    var inputForGet = { "searchtext": "", "pagenumber": 1, "pagesize": 10 };
    showLoader();
    try {
      var result = await getProcurementList(inputForGet);

      if (result && result.output.data) {
        setResultProcurementList(result.output.data);
         setTotalCount(result && result.output.count);
        if (result && result.output.count === 0 && result.output.pagesize === 0) {
          setTotalPages(1);
        } else {
          setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
        }
      }else {
        setResultProcurementList([])
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };

  useEffect(() => {
    getProcurements();
  }, [refreshPageData]);
  const fetchpaginationData = async (page) => {
    showLoader();
    try {
      const result = await getProcurementList({
        "searchtext":"",
        pagenumber: page,
        pagesize: "10"
      });

        if (result && result.output.data) {
        setResultProcurementList(result.output.data);
         setTotalCount(result && result.output.count);
        if (result && result.output.count === 0 && result.output.pagesize === 0) {
          setTotalPages(1);
        } else {
          setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
        }
      }else {
        setResultProcurementList([])
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  const handleNextClick = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchpaginationData(currentPage + 1);
  };

  const handlePreviousClick = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchpaginationData(currentPage - 1);
  };
//  ---------------------------- Add Functionality Start --------------------------------

  const openUploadInvoice = () => {
    navigate('/uploadinvoice')
  };

  const TableHeader = [
    { key: "invoicenumber", label: "Invoice Number" },
    { key: "invoicedate", label: "Invoice Date" },  
    { key: "company", label: "Company" },  
    { key: "status", label: "Payment Status" },
    { key: "pduedate", label: "Payment Date" },
    { key: "actions", label: "Actions" },
  ];
   let data = 
    [
        {
        "invoice": "15676",
        "payment_duedate": "2025-05-31",
        "status": "1",
        },
        {
          "invoice": "1558966",
          "payment_duedate": "2025-06-31",
          "status": "0",
          },
    ]
 const openInvoiceDetailsModal = async (id, invoice) => {
  setInvoiceDetailsData({
    "name_of_company": invoice.name_of_company,
    "invoice_no": invoice.invoice_no,
    "invoice_date": invoice.invoice_date,
    "GSTIN": invoice.GSTIN,
    "grand_total_amount": invoice.grand_total_amount
  })
   var inputForGet = { "invoiceid": id};
    showLoader();
    try {
      var result = await getInvoiceDetails(inputForGet);

      if (result && result.output.data) {
        setInvoiceDetails(result.output.data);
        invoicedetails.current.openRight();
      }else {
        setInvoiceDetails([])
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  
 }
   const TableHeaderInvoiceDetails = [
    //{ key: "sno", label: "S.No" },
    { key: "hsn", label: "HSN" },
    // { key: "manufacturer", label: "Manufacturer" },
    { key: "productname", label: "Product Name" },
    { key: "producttype", label: "Product Type" },
    { key: "strength", label: "Strength" },
    { key: "strengthunit", label: "Strength Unit" },
    { key: "pack", label: "Pack" },
    { key: "qty", label: "Qty" },
    { key: "mrp", label: "MRP" },
    { key: "batch", label: "Batch" },
    { key: "expiry", label: "Expiry" },
    { key: "amount", label: "Amount" },
  ];
 const updatepaymentstatus = (id, invoice) => {
  setpaymentID(id)
  setInvoiceNumber(invoice)
  paymentmodal.current.openModal()
 }
  const handlestatusSelect = (selectedOption) => {
    if(selectedOption == "Paid"){
      setPaymentStatus("1");
    }else{
      setPaymentStatus("0");
    }
    
  };
  const handlePaymentStatusChanges = async () => {
    if(!PaymentStatus.trim()){
      showErrorToast("please select any option")
      return;
    }else{
       var inputForGet = { 
          "id": paymentID,
          "paymentstatus": PaymentStatus,
       };
    showLoader();
      try {
        var result = await UpdatePaymentstatus(inputForGet);

        if (result && result.output.result == "success") {
          showSuccessToast("Payment status updated successfully")
          paymentmodal.current.closeModal();
          getProcurements();
          }else {
          showErrorToast("Somthing went wrong")
        }
      } catch (error) {
        console.log(error, "Something went wrong in doctor profile");
      } finally {
        dismissLoader();
      }
    }
    
  };
 const gobackfunction = ()=>{
  // window.history.back();
  navigate('/inventory')
 }
 //Filters
  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    //inputValue = inputValue.replace(/[^A-Za-z0-9\s@._-]/g, "").slice(0, 50);
    setSearchValue(inputValue);
  };
   async function handleFilter() {
      const trimmedName = searchValue;
     const inputToFetch = {
         "searchtext": trimmedName,
     };
     showLoader();
     try {
      var result = await getProcurementList(inputToFetch);

      if (result && result.output.data) {
        setResultProcurementList(result.output.data);
      }else {
        setResultProcurementList([])
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
   }
 
   const handleKeyDown = (event) => {
     if (event.key === "Enter") {
       handleFilter();
     }
   };
 
   async function resetFeilds() {
     setSearchValue("");
     getProcurements();
   }
  return (
    <>
      {screenType === "web" ? (
        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            {isLoading && <Loader />}
            <Box w="100%">
              <SecondaryNav withBack="Procurement Management" goBack={gobackfunction} />
              {/* <SecondaryNav customHeader="Procurement Management" goBack={gobackfunction} /> */}
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  gap="10px"
                  // pl="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by Invoice"
                    inputPlace="Search by Invoice"
                    id={"searchName"}
                    inputStyleCss={{ w: "350px" }}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => handleChangeName(e)}
                    inputValue={searchValue}
                  />
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    onClick={() => handleFilter()}
                    btnStyle={{ m: "0", w: "125px" }}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtnFull"
                    btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                    onClick={() => resetFeilds()}
                  />
                </Box>
               
                <PrimaryButton
                  buttonText="Upload Invoice"
                  onClick={openUploadInvoice}
                  btnStyle={{ m: "0" }}
                  w="125px"
                  //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
                />
              </Box>
              <Divider />
              {resultProcurementList && resultProcurementList.length > 0 ? (
                <>
                  <Box
                    width="100%"
                    //p="1rem"
                    overflow="hidden auto"
                    h="calc(100vh - 155px)"
                  >
                            <SimpleTable
                              headers={TableHeader}
                              className='tableContainer'
                              isDataPresent={true}
                              //currentPage={currentPage} onPageChange={handlePageChange}
                              footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                              tableStyle={{minH:"calc(100vh - 230px)",maxH:"calc(100vh - 230px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                              tableBody={
                                <>
                                  {resultProcurementList &&
                                    resultProcurementList.map((step, index) => (
                                      <Tr w="100%" key={index}>
                                        <Td w="100x">
                                        <Text fontSize=".875rem" fontWeight="500">
                                            {step.invoice_no ? step.invoice_no : '-'}
                                          </Text>
                                        </Td>
                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.invoice_date ? formatDate_Do_MMM_YYYY(step.invoice_date) :  '-'}
                                          </Text>
                                        </Td>
                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.name_of_company ? step.name_of_company : '-'}
                                          </Text>
                                        </Td>
                                      
                                        <Td>
                                        <Box w='fit-content'>
                                          {step.paymentstatus === 1 ? (
                                            <Text
                                            fontSize="0.75rem"
                                            borderRadius="full"
                                            fontWeight="600"
                                            p="0.25rem 0.5rem"
                                            border="1px solid #E6E7E9"
                                            // bg='#14C585'
                                            bg="#E6E7E966"
                                             color='rgb(0,151,0)'
                                            //color='rgb(255,165,0)'
                                          >
                                            Paid
                                          </Text>
                                          ) : step.paymentstatus === 0 || step.paymentstatus === null? (
                                            <Text
                                              fontSize="0.75rem"
                                              borderRadius="full"
                                              fontWeight="600"
                                              p="0.25rem 0.5rem"
                                              border="1px solid #E6E7E9"
                                              bg="#E6E7E966"
                                              color='rgb(254, 51, 51)'
                                            >
                                              Not Paid
                                            </Text>                              
                                          ):('-')}
                                        </Box>
                                        </Td>     
                                         <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.paymentdate ? formatDate_Do_MMM_YYYY(step.paymentdate) : '-'}
                                          </Text>
                                        </Td>                          
                                      <Td pos='relative'>
                                          <Menu>
                                            <MenuButton as='button'  zIndex={1}>
                                              <Image w="1.5rem" src="/assets/svgs/more-options.svg"  />
                                            </MenuButton>
                                            <MenuList zIndex={9999} pos="relative" right="-33px" minW="125px">
                                              <MenuItem  onClick={() => openInvoiceDetailsModal(step.id, step)}>
                                                View Invoice Details
                                              </MenuItem>
                                              {/* <MenuItem  onClick={() => openStockDetailsModal(step.patientid, step.appointmentid)}>
                                                View Stock Details
                                              </MenuItem> */}
                                              <MenuItem onClick={() => updatepaymentstatus(step.id, step.invoice_no)}>
                                                Edit Payment Status
                                              </MenuItem>
                                              
                                             <MenuItem
                                              onClick={() => {
                                                if (step.invoiceurl) {
                                                  downloadDocument(step.imagepath + step.invoiceurl, "Invoice");
                                                }
                                              }}
                                            >
                                              Download Invoice
                                            </MenuItem>

                                            </MenuList>
                                          </Menu>
                                        </Td>

                                      </Tr>
                                    ))}
                                </>
                              }
                              footerSection={
                                <>
                                                               <Tr>
                                                                 <Td colSpan={7} w="calc(100vw - 6.5rem)">
                                                                   <Box
                                                                     w="100%"
                                                                     display="flex"
                                                                     justifyContent="space-between"
                                                                     alignItems="center"
                                                                   >
                                                                     {/* {currentPage > 1 &&( */}
                                                                     <Box as="button" onClick={handlePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                                                       {/* <Image
                                                                         w="0.5rem"
                                                                         h="auto"
                                                                         src="/assets/imgs/left-icon.png"
                                                                         onClick={handlePreviousClick}
                                                                       /> */}
                                                                       Previous
                                                                     </Box>
                                                                     {/* )}   */}
                                                                     <Box>
                                                                       <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                                                         Page {currentPage} of {totalPages}
                                                                       </Text>
                               
                                                                     </Box>
                                                                     {/* {currentPage < totalPages &&( */}
                                                                     <Box as="button" p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} disabled={currentPage === totalPages} visibility={currentPage === totalPages ? 'hidden' : 'visible'} fontSize="1rem" fontWeight="500">
                                                                       {/* <Image
                                                                         w="0.5rem"
                                                                         h="auto"
                                                                         src="/assets/imgs/right-icon.png"
                                                                         onClick={handleNextClick}
                                                                       /> */}
                                                                       Next
                                                                     </Box>
                                                                   </Box>
                                                                 </Td>
                                                               </Tr>
                                                             </>
                              }
                            />
                          
                  </Box>
                </>
              ) : (
                <Box width="100%">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py="2rem"
                  >
                    <Text fontSize="md" fontWeight="bold">
                      No data found
                    </Text>
                  </Box>
                </Box>
              )}
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          <MobileNavbar />
          <MobileSecondaryNav
            header="Procurement Management"
            handlebackarrow={() => navigate(`/profile`)}
          />
         
        </>
      )}

          <ModalRight
            ref={invoicedetails}
            modalWidth="1200px"
            header="Invoice Details"
            body={
              <>
              {invoiceDetailsData &&
             <Box flex="1" p="24px" bg="white" borderRadius="8px">
             <Flex justify="space-between" align="start" gap="24px">
               {/* Company Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Supplier Name</Text>
                 <Box w="100%" maxW="20rem" isTruncated>
                    <Text
                    className="textOverflow"
                    title={invoiceDetailsData?.name_of_company}
                    >
                     {invoiceDetailsData?.name_of_company?invoiceDetailsData?.name_of_company:""}
                    </Text>
                  </Box>                 
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Invoice No</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{invoiceDetailsData?.invoice_no}</Text>
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Invoice Date</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{invoiceDetailsData?.invoice_date? formatDate_Do_MMM_YYYY_Time(invoiceDetailsData?.invoice_date):""}</Text>
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">GSTIN</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{invoiceDetailsData?.GSTIN?invoiceDetailsData?.GSTIN:"-"}</Text>
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Total Amount</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{invoiceDetailsData?.grand_total_amount?invoiceDetailsData?.grand_total_amount:"-"}</Text>
               </Box>
             </Flex>
           </Box>   
            }

              {InvoiceDetails && InvoiceDetails.length > 0 ? (
                  <Box my="1rem" w='100%'  mt="0.5rem">
                    <Box
                    h="calc(100vh - 90px)"
                    overflow='hidden auto'
                    border="1px solid #E6E7E9"
                    >
                      <SimpleTable
                        headers={TableHeaderInvoiceDetails}
                        className='tableContainer'
                        isThCss={{px: '0.5rem'}}
                        isDataPresent={true}
                        //currentPage={currentPage} onPageChange={handlePageChange}
                        footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                        tableStyle={{minH:"calc(100vh - 260px)",maxH:"calc(100vh - 260px)",overflow: "auto", tableLayout: "fixed", width: "100%"}}
                        tableBody={
                          <>
                            {InvoiceDetails &&
                              InvoiceDetails.map((step, index) => (
                                <Tr w="100%" key={index}>
                                
                                  <Td>
                                    <Text fontSize=".875rem" isTruncated title={step.HSN} fontWeight="500">
                                      {step.HSN ? step.HSN : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" isTruncated title={step.product_number} fontWeight="500">
                                      {step.product_number ? step.product_number : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" isTruncated title={step.product_type} fontWeight="500">
                                      {step.product_type ? step.product_type : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" isTruncated title={step.strength} fontWeight="500">
                                      {step.strength ? step.strength : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" isTruncated title={step.strengthunit} fontWeight="500">
                                      {step.strengthunit ? step.strengthunit : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.pack ? step.pack : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.qty ? step.qty : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.MRP ? step.MRP : '-'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.batch ? step.batch : '-'}
                                    </Text>
                                  </Td>

                                  

                                  <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                    {/* {step.appointmentdate ? `${formatDate(step.appointmentdate)} ${formatTime(step.appointmenttime)}`: ('-')} */}
                                    {step.exp}
                                    {/* {step.expiry_date ? (
                                      <>
                                        {formatDate(step.appointmentdate)}
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        {formatTime(step.appointmenttime)}
                                      </>
                                    ) : (
                                      '-'
                                    )} */}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.amount ? step.amount : '-'}
                                    </Text>
                                  </Td>


                                </Tr>
                              ))}
                          </>
                        }
                        footerVisible={false}
                        // footerSection={
                        //   <>
                        //   <Flex gap='1rem' p='0.75rem 0.875rem'>
                        //       <PrimaryButton variant='mdBtn' buttonText='Save' onClick={saveInvoice}/>
                        //     </Flex>
                        //   </>
                        // }
                      />
                    </Box>
                  </Box>
              ) : (
                // <SimpleTable
                //   headers={TableHeader}
                //   isDataPresent={false}
                // />
                null
              )}
              </>
            }
          />
          <DynamicModal
            ref={paymentmodal}
            modalHeader={`Update payment status - ${InvoiceNumber}`}
            modalBody={
              <>
                <Box>
                    <DropdownInput
                          variant="bothSide"
                          //defaultOption={["Not paid"]}
                          dropDownPlace={
                            <>
                              Status <Box as="span" color="red">*</Box>
                            </>
                          }
                          options={["Paid", "Not paid"]}
                          onClick={handlestatusSelect}
                        />
                  
                </Box>
              </>
            }
            modalFooterBtn={
              <>
                <PrimaryButton buttonText="Update" 
                onClick={handlePaymentStatusChanges} 
                />
              </>
            }
          />
    </>
    
  );
};

export default ProcurementsIndex;
